import { careerPath, images } from "../data/portfolioData";

function ChapterJourney() {
  return (
    <section id="works" className="chapter journey-section" data-section="works" data-testid="chapter-03-works">
      <div className="chapter-intro">
        <div className="section-kicker"><span>03</span><span>THE JOURNEY SO FAR</span></div>
        <div><h2 data-testid="chapter-03-heading">A career built in layers.</h2><p className="chapter-lead">From support desks and web products to cloud architecture and keynote rooms — every role added a new way to make technology useful.</p></div>
      </div>
      <div className="journey-layout">
        <div className="journey-gallery">
          <figure className="journey-image journey-image-wide"><img src={images.seated} alt="Armand seated at a technology event" /><figcaption>Listen first. Design second.</figcaption></figure>
          <figure className="journey-image journey-image-tall"><img src={images.stage} alt="Armand presenting on stage" /><figcaption>Make the complex memorable.</figcaption></figure>
        </div>
        <div className="timeline" aria-label="Career timeline">
          {careerPath.map((item, index) => (
            <article className="timeline-card reveal-item" key={`${item.period}-${item.title}`} data-testid={`timeline-item-${index}`}>
              <div className="timeline-period">{item.period}</div>
              <div><h3>{item.title}</h3><span className="timeline-company">{item.company}</span><p>{item.body}</p></div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ChapterJourney;
